function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { initializerDefineProperty as _initializerDefineProperty, applyDecoratedDescriptor as _applyDecoratedDescriptor } from "../_virtual/_rollupPluginBabelHelpers.js";
import { observable, action } from 'mobx';
import { isError } from 'lodash';

var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _temp;

var SignatureStore = (_class = (_temp = /*#__PURE__*/_createClass(function SignatureStore(pdfStore) {
  var _this = this;

  _classCallCheck(this, SignatureStore);

  this.pdfStore = void 0;

  _initializerDefineProperty(this, "signature", _descriptor, this);

  _initializerDefineProperty(this, "dateSigned", _descriptor2, this);

  _initializerDefineProperty(this, "signatureModalOpen", _descriptor3, this);

  _initializerDefineProperty(this, "signField", _descriptor4, this);

  _initializerDefineProperty(this, "setSignature", _descriptor5, this);

  _initializerDefineProperty(this, "setDateSigned", _descriptor6, this);

  _initializerDefineProperty(this, "setSignatureModalOpen", _descriptor7, this);

  this.signatureValid = function (signature) {
    return !isError(_this.validateFullName(signature.fullName)) && !isError(_this.validateInitials(signature.initials));
  };

  this.validateNotBlank = function (input) {
    if (input.length === 0) {
      return new Error("Can't be blank");
    }

    return null;
  };

  this.validateFullName = function (fullName) {
    var blankError = _this.validateNotBlank(fullName);

    if (blankError) return blankError;
    var format = /^([A-z][A-Za-z\s\-.']{0,26})?$/;

    if (!format.test(fullName)) {
      return new Error('Can only contain letters and punctuation (max 26)');
    }

    return null;
  };

  this.validateInitials = function (initials) {
    var blankError = _this.validateNotBlank(initials);

    if (blankError) return blankError;
    var format = /^[A-Z]{0,4}$/;

    if (!format.test(initials)) {
      return new Error('Can only contain letters (max 4)');
    }

    return null;
  };

  this.pdfStore = pdfStore;
}), _temp), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "signature", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dateSigned", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "signatureModalOpen", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return false;
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "signField", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this2 = this;

    return function (field) {
      if (!field) return;

      if (!_this2.signature || !_this2.signatureValid(_this2.signature)) {
        _this2.signatureModalOpen = true;
        return;
      }

      if (field.data.valueType === 'signature') {
        field.data.value = _this2.signature.fullName;
      } else {
        field.data.value = _this2.signature.initials;
      }

      field.setValueWasModified(true);
    };
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "setSignature", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this3 = this;

    return function (fullName, initials) {
      _this3.signature = {
        fullName: fullName,
        initials: initials
      };
    };
  }
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "setDateSigned", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this4 = this;

    return function (dateSigned) {
      _this4.dateSigned = dateSigned;
    };
  }
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "setSignatureModalOpen", [action], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    var _this5 = this;

    return function (isOpen) {
      _this5.signatureModalOpen = isOpen;
    };
  }
})), _class);
export default SignatureStore;